<p>info-add works!</p>
